
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Nav, Tab } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faPlug, faUsers } from "@fortawesome/free-solid-svg-icons";
import { Breadcrumb } from '@themesberg/react-bootstrap';

import { DeviceTable } from '../../commons/device/partials/DeviceTable';
import { EmployeeTable } from '../../account/employee/partials/EmployeeTable';

export default () => {
  const [activeTab, setActiveTab] = useState('devices');

  useEffect(() => {
    document.title = "Cài đặt"
  }, []);

  return (
    <>
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
            <Breadcrumb.Item active>Cài đặt</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Quản lý hệ thống</h4>
          <p className="mb-0">Quản lý thiết bị và nhân viên</p>
        </div>
      </div>

      <Container fluid>
        <Row>
          <Col>
            <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
              <Nav variant="tabs" className="mb-4">
                <Nav.Item>
                  <Nav.Link eventKey="devices">
                    <FontAwesomeIcon icon={faPlug} className="me-2" />
                    Thiết bị USB
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="employees">
                    <FontAwesomeIcon icon={faUsers} className="me-2" />
                    Nhân viên
                  </Nav.Link>
                </Nav.Item>
              </Nav>

              <Tab.Content>
                <Tab.Pane eventKey="devices">
                  <DeviceTable />
                </Tab.Pane>
                <Tab.Pane eventKey="employees">
                  <EmployeeTable />
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
    </>
  );
};
